module.exports = __webpack_public_path__ + "img/ic_mic_mute.1ce7bbc8.svg";